export default __webpack_public_path__ + "static/media/ILPlatform_AboutUs.0e2dd253.webp";